<template>
<div>
  <div>
    <label :for="field.id">{{label}} </label>
    <v-select :id="field.id" class="wrap-label" :items="values" item-text="value" item-value="key" :menu-props="{ maxHeight: '400' }" v-model="model"></v-select>
  </div>
    <!--  <v-select class="wrap-label" :items="values" item-text="value" item-value="key" :menu-props="{ maxHeight: '400' }" :label="label" v-model="model"></v-select>-->
  {{ description }}
</div>
</template>

<script>
import {
  input
} from '@/mixins/input'
import Cookies from 'js-cookie'

export default {
  computed: {
    lang() {
      return this.$store.state.lang
    },
    values() {
      console.log(this.$store.state.forms.schema)
      return this.field.values
    }
  },
  mixins: [input]
}
</script>

<style>

</style>
